import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2, KeyRound, ShieldCheck } from 'lucide-react';
import api from '../lib/api';
import './console.css';

export default function PlatformInvitePage() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ next: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/platform-invites/${token}`).then(r => setInvite(r.data))
      .catch(e => setError(e?.response?.data?.detail || 'This invite link is no longer valid.'));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.next.length < 12) return setError('Choose a password of at least 12 characters.');
    if (form.next !== form.confirm) return setError('The two passwords do not match.');
    setBusy(true);
    try { await api.post(`/platform-invites/${token}/accept`, { password: form.next }); setDone(true); }
    catch (err) { setError(err?.response?.data?.detail || 'Could not set your password.'); } finally { setBusy(false); }
  };

  return (
    <div className="pc-shell pc-login-shell" data-testid="pc-invite-page">
      <div className="pc-login-card">
        {done ? (
          <>
            <h1 className="pc-h1"><ShieldCheck className="h-5 w-5" /> You are all set</h1>
            <p className="pc-sub">Sign in with {invite?.email} and your new password.</p>
            <Link className="pc-btn pc-btn-primary pc-login-submit" to="/platform" data-testid="pc-invite-signin">Go to the console</Link>
          </>
        ) : !invite ? (
          <>
            <h1 className="pc-h1">Platform console invite</h1>
            {error ? <p className="pc-sub" data-testid="pc-invite-error">{error}</p>
              : <p className="pc-sub" data-testid="pc-invite-loading"><Loader2 className="h-4 w-4 animate-spin" /> Checking your invite…</p>}
          </>
        ) : (
          <form onSubmit={submit}>
            <h1 className="pc-h1">Set your console password</h1>
            <p className="pc-sub" data-testid="pc-invite-who">{invite.name} · {invite.email} · {invite.role_name}</p>
            <label className="pc-login-field">New password<input className="pc-input" type="password" required minLength={12} value={form.next} onChange={e => setForm(f => ({ ...f, next: e.target.value }))} autoComplete="new-password" data-testid="pc-invite-password" /></label>
            <label className="pc-login-field">Confirm password<input className="pc-input" type="password" required minLength={12} value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} autoComplete="new-password" data-testid="pc-invite-confirm" /></label>
            {error && <p className="pc-sub" data-testid="pc-invite-error">{error}</p>}
            <button className="pc-btn pc-btn-primary pc-login-submit" disabled={busy} data-testid="pc-invite-submit">
              {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <KeyRound className="h-3.5 w-3.5" />} Save password
            </button>
            <p className="pc-muted">At least 12 characters with upper and lower case, a number and a symbol. You can also sign in with Google using this email.</p>
          </form>
        )}
      </div>
    </div>
  );
}
